import {Component, inject, OnInit, PLATFORM_ID} from '@angular/core';
import {Timeline} from 'primeng/timeline';
import {PrimeTemplate} from 'primeng/api';
import {Button} from 'primeng/button';
import {NavigatorDirective} from '../../../shared/directive/navigator.directive';
import {TimelineStep} from '../../../shared/model/timeline-step.model';
import {formComponentSignal} from '../../../shared/signal/common/form-component.signal';
import {RichResultsService} from '../../../shared/rich-results/rich-results.service';
import {buildHowToSection} from '../../../shared/rich-results/rich-results.builders';
import {RichResultsTypes} from '../../../shared/enum/rich-results-types.enum';
import {isPlatformBrowser} from '@angular/common';
import {AnalyticsEventCategory, AnalyticsEventName} from '../../../shared/enum/gtm-cookie-consent.enum';
import {Theme} from '../../../shared/enum/theme.enum';
import {GoogleAnalyticsService} from '../../../shared/analytics/google/google-analytics.service';
import {PixelEventName} from '../../../shared/analytics/meta/types/pixel.types';
import {PixelService} from '../../../shared/analytics/meta/pixel.service';

@Component({
  selector: 'app-auctions-steps',
  imports: [
    Timeline,
    PrimeTemplate,
    Button,
    NavigatorDirective
  ],
  templateUrl: './auctions-steps.component.html',
  styleUrl: './auctions-steps.component.scss'
})
export class AuctionsStepsComponent implements OnInit {
  protected timelineSteps: TimelineStep[] = [
    {
      icon: 'pi pi-file-edit',
      title: 'Rozpocznij proces online',
      description: 'Wypełnij prosty formularz kontaktowy podstawowymi informacjami i preferencjami. To zajmie tylko chwilę, a my natychmiast otrzymamy Twój wniosek i rozpoczniemy jego weryfikację.',
      ctaText: 'Przejdź do formularza',
      ctaLink: '#formularz'
    },
    {
      icon: 'pi pi-comments',
      title: 'Konsultacja ekspercka',
      description: 'Nasz doradca leasingowy skontaktuje się z Tobą w ciągu 24 godzin roboczych. Omówimy Twoje potrzeby, przedstawimy dostępne opcje finansowania i odpowiemy na wszystkie pytania. Razem wybierzemy najlepsze rozwiązanie dla Twojej firmy.'
    },
    {
      icon: 'pi pi-check-circle',
      title: 'Finalizacja i odbiór',
      description: 'Po pozytywnej weryfikacji wniosku przygotujemy dokumenty do podpisu. Możesz podpisać umowę elektronicznie lub w naszym biurze. Po sfinalizowaniu formalności odbierasz swój wymarzony pojazd i możesz ruszyć w drogę!'
    }
  ];
  protected readonly formComponentSignal = formComponentSignal;
  protected readonly platformId = inject(PLATFORM_ID);

  constructor(
    private readonly richResultsService: RichResultsService,
    private readonly googleAnalyticsService: GoogleAnalyticsService,
    private readonly pixelService: PixelService) {
  }

  ngOnInit(): void {
    this.constructSchema();
  }

  private constructSchema(): void {
    const howToSchema = buildHowToSection({
      name: 'Trzy proste kroki dzielą Cię od wymarzonego auta dla Twojej firmy',
      itemListElement: this.timelineSteps.map((step, idx) => ({
        '@type': RichResultsTypes.ListItem,
        position: idx + 1,
        item: {
          '@type': RichResultsTypes.Thing,
          name: step.title,
          description: step.description
        }
      }))
    });

    this.richResultsService.register(howToSchema);
  }

  protected onCtaClick(): void {
    this.googleAnalyticsService.trackEvent({
      event: AnalyticsEventName.RequestCtaClick,
      eventCategory: AnalyticsEventCategory.CTA,
      eventPayload: Theme.AUCTIONS
    });

    this.pixelService.trackEvent(
      PixelEventName.RequestCta, {
        page: Theme.AUCTIONS
      });
  }
}
